import ConfirmOverlay from '../../components/posa/ConfirmOverlay';
import CtaSection from '../../components/posa/CtaSection';
import FaqSection from '../../components/posa/FaqSection';
import MetaTags from '../../components/MetaTags';
import PosaCardRedeemViewStyled from './PosaCardRedeemViewStyled';
import PosaCardSuccessView from './PosaCardSuccessView';
import {PosaMessageProvider} from '../../context/PosaMessageContext';
import PosaRedeemActions from '../../actions/PosaRedeemActions';
import PosaRedeemStore from '../../stores/PosaRedeemStore';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemSection from '../../components/posa/RedeemSection';
import {Redirect, withRouter} from 'react-router';
import RichText from '../../components/posa/RichText';
import {connectToStores} from 'epic-alt-utils';
import cx from 'classnames';
import epicTracking from 'epic-tracking';
import queryString from 'query-string';
import root from 'window-or-global';
import {generateRouteTo} from '../../utils/route';
import GiftcardBanner from '../../components/posa/GiftcardBanner';

/**
 * POSA Card Redeem View.
 */
@connectToStores
class PosaCardRedeemView extends React.Component {
  static propTypes = {
    posaRedeemStore: PropTypes.object,
    location: PropTypes.object,
    redeemStore: PropTypes.object,
    loadScreen: PropTypes.node,
    notFoundRedirect: PropTypes.node,
    uppercaseCode: PropTypes.bool,
    loginAction: PropTypes.func,
    ctaAction: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    accountName: PropTypes.string,
    giftcardConfig: PropTypes.object,
  };

  static getStores() {
    return [PosaRedeemStore];
  }

  static getPropsFromStores() {
    return {
      posaRedeemStore: PosaRedeemStore.getState(),
    };
  }

  static getInitialActions() {
    return [
      (props) => {
        const {page} = props.posaRedeemStore;
        if (!page) {
          PosaRedeemActions.getCmsContent();
        }
      },
    ];
  }
  state = {
    landingPageViewed: false,
  };

  constructor(props) {
    super(props);
    let landingPageViewed = false;
    try {
      const qs = queryString.parse(props.location.search);
      if (qs.fromCta) {
        landingPageViewed = true;
      }
      if (qs.code) {
        landingPageViewed = true;
      }
    } catch (ex) {
      // no-op
    }
    this.state = {
      landingPageViewed,
      showBonusSection: true,
    };
  }

  // we always show unloggedIn section until use clicked "Get Started" button
  setViewed = () => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'PosaRedeem',
      eventAction: 'getstarted',
    });
    this.setState({
      landingPageViewed: true,
    });
  };

  getStartAction = (warningContent) => {
    const {loginAction, isLoggedIn} = this.props;
    if (!isLoggedIn) {
      loginAction(warningContent);
    } else {
      this.setViewed();
    }
  };
  getMetaTags = () => {
    const {
      page: {metaTags},
    } = this.props.posaRedeemStore;
    return <MetaTags meta={metaTags} />;
  };
  renderLoading = () => {
    const loading = this.props.loadScreen || <div className="loading" />;
    return loading;
  };
  render404 = () => {
    const {notFoundRedirect} = this.props;
    return (
      notFoundRedirect || <Redirect to={generateRouteTo('page-not-found', this.props.location)} />
    );
  };

  resetFlow = () => {
    root.scrollTo(0, 0);
    PosaRedeemActions.resetFlow();
  };

  renderSuccessView = () => {
    const {ctaAction} = this.props;
    const {showBonusSection} = this.state;
    return (
      <>
        {this.getMetaTags()}
        <PosaCardSuccessView
          ctaAction={ctaAction}
          resetFlow={this.resetFlow}
          trackEvent={PosaRedeemActions.track}
          showBonusSection={showBonusSection}
        />
      </>
    );
  };
  renderMainPage = () => {
    const {
      page: {
        messages,
        sections: {sections},
        configs: {id},
        loginModal,
      },
      codeVerified,
    } = this.props.posaRedeemStore;
    const {location} = this.props;
    const code = location.search ? queryString.parse(location.search).code || '' : '';
    const {landingPageViewed, showBonusSection} = this.state;
    const {ctaAction, isLoggedIn, accountName, uppercaseCode, giftcardConfig} = this.props;
    const {posaGiftCardBannerShow, posaGiftCardRedeemUrl} = giftcardConfig;
    const list = sections.map((section) => {
      let jsx = null;
      for (const prop in section) {
        if (Object.hasOwn(section, prop)) {
          const data = section[prop];
          if (typeof data === 'object') {
            const {_type} = data;
            switch (_type) {
              case 'POSA Redeem Section':
                jsx = (
                  <RedeemSection
                    landingPageViewed={landingPageViewed}
                    data={data}
                    prefilledCode={code}
                    accountName={accountName}
                    uppercaseCode={uppercaseCode}
                    key={_type}
                    isLoggedIn={isLoggedIn}
                    getStartAction={this.getStartAction}
                    loginModal={loginModal}
                    posaRedeemStore={this.props.posaRedeemStore}
                    giftcardConfig={giftcardConfig}
                  />
                );
                break;
              case 'POSA FAQ Section':
                jsx = <FaqSection data={data} key={_type} />;
                break;
              case 'POSA CTA Section':
                jsx = <CtaSection data={data} key={_type} ctaAction={ctaAction} />;
                break;
              case 'POSA Rich Text':
                jsx = <RichText data={data} key={_type} />;
                break;
              default:
              // no-op
            }
          }
        }
      }
      return jsx;
    });

    const classNames = cx(
      `epic-code-redemption posaRedeemView ${isLoggedIn ? 'loggedIn' : 'unloggedIn'}`,
      {
        codeVerified,
        landingPageViewed,
      }
    );

    const close = () => PosaRedeemActions.setShowConfirm(false);
    const redeemFunc = () => {
      root.scrollTo(0, 0);
      PosaRedeemActions.redeemCode();
    };
    return (
      <PosaMessageProvider value={JSON.parse(messages)}>
        {this.getMetaTags()}
        <PosaCardRedeemViewStyled className={classNames} id={id}>
          {posaGiftCardBannerShow && (
            <GiftcardBanner posaGiftCardRedeemUrl={posaGiftCardRedeemUrl} />
          )}
          {list}
          <ConfirmOverlay
            posaRedeemStore={this.props.posaRedeemStore}
            close={close}
            redeemFunc={redeemFunc}
            resetFlow={this.resetFlow}
            showBonusSection={showBonusSection}
          />
        </PosaCardRedeemViewStyled>
      </PosaMessageProvider>
    );
  };

  render() {
    const {loading, page, redeemed} = this.props.posaRedeemStore;

    if (loading) return this.renderLoading();

    try {
      if (!page) {
        console.error('PosaCardRedeemView: rendering 404 - page is missing');
        return this.render404();
      }
      if (!page.configs.enablePOSA) {
        console.error(
          'PosaCardRedeemView: rendering 404 - enablePOSA config is missing/false',
          page.configs
        );
        return this.render404();
      }
    } catch (ex) {
      console.error('PosaCardRedeemView: rendering 404 - exception accessing page.configs', ex);
      return this.render404();
    }

    if (redeemed) return this.renderSuccessView();

    return this.renderMainPage();
  }
}

export default withRouter(PosaCardRedeemView);
